import TrainingAdminPage from 'react-components/admin/training-admin-page';
import { Routes, SyncHook } from '../route-types';

const useSyncHook: SyncHook = null;

// const routes: Routes = [
//   { path: '/training-admin', element: <TrainingAdminPage /> },
// ];

const routes: Routes = [
  {
    path: '/training-admin',
    element: <TrainingAdminPage />,
  },
];

const useNavigationHooks = () => {
  return {};
};

export const trainingAdminPageRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
